import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar,
  IonicSlides,
} from "@ionic/react";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { close as ci } from "ionicons/icons";
import _ from "lodash";
import { ItemImage } from "../apollo-client/types";
import { useTranslation } from "react-i18next";

import "./imageModal.css";

type ModalProps = {
  images: ItemImage[];
  activeSlide: number | undefined;
  close: () => void;
};

const ImageModal: React.FC<ModalProps> = ({ images, activeSlide, close }) => {
  const { t } = useTranslation();
  return (
    <IonPage className="showPaymentsContainer">
      <IonHeader>
        <IonToolbar color="secondary">
          <IonTitle>{t("product_details.gallery")}</IonTitle>
          <IonButtons slot="start">
            <IonButton onClick={() => close()}>
              <IonIcon icon={ci} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <Swiper
          className="images"
          modules={[Pagination, IonicSlides]}
          pagination={true}
          initialSlide={activeSlide}
        >
          {_.sortBy(images, (s) => -s.position).map((image, index) => (
            <SwiperSlide key={index}>
              <div
                className="image"
                style={
                  image ? { backgroundImage: `url('${image.imageUrl}')` } : {}
                }
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </IonContent>
    </IonPage>
  );
};

export default ImageModal;
